
export default function Wildlife() {
  const wildlife = [
    {
      name: 'Great Blue Heron',
      description: 'Majestic wading birds often seen along the shoreline hunting for fish in the shallow waters.',
      image: 'https://public.readdy.ai/ai/img_res/c0706c0745e08a3a1c84c15fa23e4d0f.jpg',
      season: 'Year-round',
    },
    {
      name: 'White-tailed Deer',
      description: 'Graceful deer frequently spotted near the lake during early morning and evening hours.',
      image: 'https://readdy.ai/api/search-image?query=white%20tailed%20deer%20standing%20near%20lake%20edge%20drinking%20water%20with%20forest%20background%20gentle%20wildlife%20natural%20habitat%20peaceful%20lakeside%20scene%20beautiful%20brown%20coat%20alert%20pose%20serene%20nature%20photography&width=600&height=400&seq=wildlife-002&orientation=landscape',
      season: 'Year-round',
    },
    {
      name: 'Bald Eagle',
      description: 'Powerful raptors soaring above the lake, diving to catch fish with incredible precision.',
      image: 'https://readdy.ai/api/search-image?query=bald%20eagle%20flying%20over%20blue%20lake%20water%20majestic%20wingspan%20hunting%20fish%20clear%20sky%20background%20powerful%20raptor%20wildlife%20photography%20natural%20habitat%20beautiful%20white%20head%20brown%20body%20soaring%20gracefully&width=600&height=400&seq=wildlife-003&orientation=landscape',
      season: 'Winter & Spring',
    },
    {
      name: 'River Otter',
      description: 'Playful otters diving and swimming in the lake, entertaining visitors with their antics.',
      image: 'https://readdy.ai/api/search-image?query=river%20otter%20swimming%20playfully%20in%20clear%20blue%20lake%20water%20cute%20wildlife%20natural%20habitat%20diving%20and%20playing%20smooth%20fur%20happy%20expression%20peaceful%20lakeside%20environment%20nature%20photography&width=600&height=400&seq=wildlife-004&orientation=landscape',
      season: 'Year-round',
    },
    {
      name: 'Painted Turtle',
      description: 'Colorful turtles basking on logs and rocks, soaking up the warm sunshine.',
      image: 'https://readdy.ai/api/search-image?query=painted%20turtle%20basking%20on%20log%20in%20lake%20colorful%20shell%20pattern%20sunny%20day%20clear%20blue%20water%20background%20natural%20wildlife%20habitat%20peaceful%20scene%20beautiful%20markings%20relaxing%20pose&width=600&height=400&seq=wildlife-005&orientation=landscape',
      season: 'Spring & Summer',
    },
    {
      name: 'Loon',
      description: 'Iconic lake birds known for their haunting calls echoing across the water at dawn and dusk.',
      image: 'https://readdy.ai/api/search-image?query=common%20loon%20bird%20swimming%20on%20calm%20blue%20lake%20water%20distinctive%20black%20and%20white%20plumage%20red%20eyes%20peaceful%20natural%20habitat%20beautiful%20reflection%20serene%20lakeside%20scene%20wildlife%20photography&width=600&height=400&seq=wildlife-006&orientation=landscape',
      season: 'Spring & Summer',
    },
  ];

  return (
    <section id="wildlife" className="py-24 px-6 bg-gradient-to-b from-white to-sky-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Wildlife at The Way Lake
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience the diverse ecosystem thriving in and around our pristine waters
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {wildlife.map((animal, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full h-64">
                <img
                  src={animal.image}
                  alt={animal.name}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute top-4 right-4 bg-sky-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                  {animal.season}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{animal.name}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{animal.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
